import { createAction } from '@reduxjs/toolkit';

import type { RanData, ShortUrl, ShortUrlState } from './types';

export const updateRanData = createAction<RanData>('UPDATE_RAN_DATA');

export const setShortUrl = createAction<ShortUrl>('SET_SHORT_URL');

export const updateShortUrl = createAction<{
  [key: string]: ShortUrlState;
}>('UPDATE_SHORT_URL');
